import { createRouter, createWebHistory } from 'vue-router';  
import PreRegistration from '../components/HomePage.vue';
import SuccessPage from '../components/SuccessPage.vue'; // 引入新组件

const routes = [
  {
    path: '/',
    name: 'PreRegistration',
    component: PreRegistration,
  },
  {
    path: '/success',
    name: 'SuccessPage',
    component: SuccessPage,
  },
  // 可能还有其他路由配置
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;